<script>
  
  export let 
    paused = true, 
    transparent = false,
    style = null,
    mint = false

</script>

<svg class:mint {style} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle class:transparent cx="30" cy="30" r="30"/>
  {#if !paused}
    <rect x="18" y="15" width="8" height="30"/>
    <rect x="34" y="15" width="8" height="30"/>
  {:else}
    <path d="M46.5882 30L21 45L21 15L46.5882 30Z"/>
  {/if}
</svg>

<style lang="scss">
  circle {
    fill: $color-red;
    &.transparent {
      fill: transparent;
    }
  }
  rect, path {
    fill: $color-beige;
    .mint & {
      fill: $color-mint;
    }
  }
</style>